import { render } from "./_IndexAddendum.vue?vue&type=template&id=0a8c7fea"
import script from "./_IndexAddendum.vue?vue&type=script&lang=js"
export * from "./_IndexAddendum.vue?vue&type=script&lang=js"

import "./_IndexAddendum.vue?vue&type=style&index=0&id=0a8c7fea&lang=css"
import "./_IndexAddendum.vue?vue&type=style&index=1&id=0a8c7fea&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__